export default "__VITE_ASSET__BjCR4ImJ__"